import {
  createSearchParams,
  Location,
  NavigateOptions,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import { RouteEnum } from '@/models/route/Route.model.ts';

type PathParams = { params: Record<string, string>; pathname: Path } | Path;
type Path = RouteEnum | string;

interface Return {
  location: Location;
  push: (path: PathParams, state?: NavigateOptions) => void;
}

export const useKnowMeNavigate = (): Return => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    location,
    push: (path, state) => {
      if (typeof path === 'object') {
        void navigate(
          {
            pathname: path.pathname,
            search: `?${createSearchParams(path.params)}`,
          },
          state,
        );
        return;
      }
      void navigate(path, state);
    },
  };
};
